import _ from 'lodash';

export default function getHighestPercentageAboveAverage(allNumbers: number[]): number {
  const sum = _.sum(allNumbers);
  const average = sum / allNumbers.length;
  const highest = _.max(allNumbers) ?? 0;
  return Math.round(((highest - average) / average) * 100);
}
